import wallets from './wallets.json';

export default function WalletChecker(walletAddress) {
    const regex = new RegExp(wallets.join( "|" ), "i");
    return regex.test(walletAddress.trim());
}